import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isCancelledError } from "react-query";
import { ApiError, type Error } from "../api";
import { InternationalizableError } from "../errors";

// A cancelled/aborted request (e.g. react-query cancelling an in-flight
// refetch, or a fetch aborted via AbortController on navigation) is not a
// user-facing failure: the request never completed and produces no response
// body, so it must never be rendered as an error.
function isCancellation(error: any): boolean {
  return (
    isCancelledError(error) ||
    error?.name === "CancelError" ||
    error?.name === "AbortError"
  );
}

export default function ErrorAlert(props: { error: any }) {
  if (isCancellation(props.error)) return null;
  return (
    <Alert severity="error">
      <ErrorMessage {...props} />
    </Alert>
  );
}

function ErrorMessage({ error }: { error: any }) {
  const { t } = useTranslation("errors");

  if (error instanceof ApiError) {
    const e = (error.body ?? {}) as Error;
    if (e.code) return <>{t(e.code)}</>;
    if (e.message) return <>{e.message}</>;
  }

  if (error instanceof InternationalizableError) {
    const e = error as InternationalizableError;
    if (e.code) return <>{t(e.code)}</>;
  }

  return <>{error?.message}</>;
}
